/** 
 *  Constants For Ticket Types Categories
 */
export enum TicketTypeCategoriesConstants {

	/**
     * Constant for HOLIDAY_REQUEST
     */
    HOLIDAY_REQUEST = "db7a448e-4a16-406f-9028-860705bde76d",

    /**
     * Constant for ABSENCE_REQUEST
     */
    ABSENCE_REQUEST = "e1433967-ea36-413f-a385-fdef4b4709c5",
}